import React from 'react';
import ProfileMenu from '../components/ProfileMenu.tsx';
import { useAuth } from '../context/authContext.tsx';
import { digitalOceanImageUrl } from "../utils/digitalOcean.ts";

interface MainLayoutProps {
  children: React.ReactNode;
}


const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const {employeeI} = useAuth();
  return (
    <div className="min-h-screen bg-blue-900">
      <header className=" shadow-sm">
        <div className="max-w-7xl mx-auto px-2 sm:px-1 lg:px-1">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0">
              {/* Add your logo here */}
              <img
                className="h-5 w-auto"
                src={digitalOceanImageUrl("new%20logos/Asset%204.png")}
                alt="Company Logo"
              />
            </div>
            
            
            
            <div className="flex items-center">
              <ProfileMenu />
            </div>
           
          </div>
        </div>
      </header>

      <main className="">
        {children}
      </main>
    </div>
  );
};

export default MainLayout; 